import { z } from "zod";
import AuthService from "../../../services/AuthService";
import { AxiosError, AxiosResponse } from "axios";
import { mapErrorsToFields } from "../../../utils";

export type State = {
  errors?: {
    phone?: string[];    
    code?: string[];
    verificationId?: string[];
    rememberMe?: string[];
    general?: string[];
  };
  success?: boolean;
  message?: string | null;
  defaultValues?: {
    phone: string; 
    code: string;
    verificationId: string;
    rememberMe: boolean;
  };
  data?: {verificationId:string};
};

const FormSchema = z.object({
  phone: z.string({
    error: "Phone number is required",
  }),
  verificationId: z.string({
    error: "VerificationId is required",
  })  ,
  token: z.string({
    error: "Code is required",
  }).length(6, { message: "Code must be equal 6 characters" }),
  rememberMe: z.boolean({
    error: "Remember me is required",
  })
});
export async function verifyPhone(
    prevState: State | undefined,
    data: FormData
  ): Promise<State> {
    const defaultValues = {
      phone: data.get("phone")?.toString() || "",      
      verificationId: data.get("verificationId")?.toString() || "",
      token: data.get("code")?.toString() || "",
      rememberMe: data.get("rememberMe") === "on",
    };
    console.log(defaultValues);
    const result = FormSchema.safeParse(defaultValues);
    if (!result.success) {
      const errors = mapErrorsToFields(result.error);
      return { ...prevState, errors };
    }
    const api = new AuthService();
    try {
      const response: any = await api.verifyPhone({
        phone: defaultValues.phone,
        verificationId: defaultValues.verificationId,
        token: defaultValues.token,
        rememberMe: defaultValues.rememberMe,
        JWTonly:false
      });
    return { ...prevState, success: true };
  } catch (ex: AxiosError | any) {
    console.log({ ex });
    return { ...prevState, errors: { general: [ex.response.data.description] } };
  }
}